import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./appInsights";

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView({
      name: location.pathname,
      uri: window.location.href,
    });
  }, [location.pathname]);

  return null;
}
